import dynamic from 'next/dynamic';
import { CheckoutRoomCardProps } from './CheckoutRoomCard.types';

export const CheckoutRoomCard = dynamic<CheckoutRoomCardProps>(() => {
  return import('./CheckoutRoomCard').then(module => module.CheckoutRoomCard);
});
